import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";

const initialState = {} as IDataRequest;

const dataRequestSlice = createSlice({
    name: "dataRequest",
    initialState,
    reducers: {
        setDataRequest: (state, action: PayloadAction<IDataRequest | undefined>) => {
            Object.assign(state, action.payload);
        },
    },
});

export const { setDataRequest } = dataRequestSlice.actions;
export default dataRequestSlice.reducer;

export const getDataRequest = (state: RootState) => state.dataRequest;
